import { useEffect, useState } from "react";
import { Box } from "@mui/material";
import { PaymentRequestButtonElement } from "@stripe/react-stripe-js";

const AppleGooglePayButtonStripe = ({
  handlePaymentRequest,
  paymentRequest
}) => {
  const [isProcessing, setIsProcessing] = useState(false);

  useEffect(() => {
    if (paymentRequest) {
      // Handle payment request cancellation
      const handleCancel = () => {
        console.log('Payment request cancelled');
        setIsProcessing(false);
      };

      // Handle payment request ready
      const handleReady = () => {
        console.log('Payment request ready');
        setIsProcessing(false);
      };

      // Add event listeners
      paymentRequest.on("cancel", handleCancel);
      
      // Cleanup function
      return () => {
        paymentRequest.off("cancel", handleCancel);
      };
    }
  }, [paymentRequest]);

  const handleClick = (event) => {
    if (isProcessing) {
      return;
    }
    
    setIsProcessing(true);
    
    try {
      handlePaymentRequest();
    } catch (error) {
      console.error('Error handling payment request:', error);
      setIsProcessing(false);
    }
  };

  if (!paymentRequest) {
    return null;
  }

  return (
    <Box style={{ flex: 1 }}>
      <PaymentRequestButtonElement
        id="payment-button"
        options={{
          style: {
            paymentRequestButton: {
              type: "buy",
              theme: "dark",
              height: "40px",
            },
          },
          paymentRequest,
        }}
        onClick={handleClick}
      />
    </Box>
  );
};

export default AppleGooglePayButtonStripe;
